const mockAttemptsToContactByPhone = { attempted: 5, successful: 0 }

export default mockAttemptsToContactByPhone
